/**
 * Author：tanyaohua 2020-05-12
 * discription: 在微博渠道中增加账户有效期检测的提醒
 * 1.在采编中心中点击待编、待审、已签发中如果有效期小于三天，则在右下角弹框提示。
 * 2.在签发操作之前也要判断一下是否有效期内，如果不是，在中间弹框提醒用户绑定
 * ps:2020-0813 废弃，挪到app\components\service\noticeWindowTip\noticeWindowTip.js
 */
'use strict';
angular.module('accountValidityServiceModule', ['noticeWindowModule'])
    .factory('accountValidityService', ['$q', 'modalDialog', 'trsHttpService', 'publicToolService', '$state', function ($q, modalDialog, trsHttpService, publicToolService, $state) {
        return {

            /**
             * [params description]用于校验账号有效期 是否过期
             *
             * @param   {[type]}  MediaType  [MediaType description]
             * @param   {[type]}  channel  [tranch description]
             *
             * @return  {[type]}          [return description]
             */
            getAccountValidityInfo: function (MediaType, channel) {
                var defer = $q.defer();
                var params = {
                    MediaType: MediaType,
                    methodname: 'checkAccountValidity',
                    serviceid: 'zmy_product',
                    // productId: channel.ACCOUNTID,
                };
                // 做个兼容
                if (channel) {
                    params.productId = channel.ACCOUNTID || channel.DOUYINACCOUNTID;
                } else {
                    params.productId = $state.params.accountid || $state.params.account || $state.params.wbchannelid;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function (data) {
                        if (channel) {
                            if (data.TYPE === '3' || data.TYPE === '2') { 
                                publicToolService.createWindow('./editingCenter/service/accountValidity/accountValidity.html', data);
                            }
                            defer.reject();
                        } else {
                            if (data.TYPE === '3') {
                                modalDialog.alertType('您的账号已经过期，无法发布，是否重新绑定', '', 'ask', true, function(){
                                    // 这是确定回调
                                    window.open(data.URL);
                                    defer.reject();
                                
                                }, function(){
                                    // 这是取消回调
                                    defer.reject();
                                }, '', '取消', '确定');
                            
                                // defer.resolve(data);
                            } else {
                                defer.resolve(data);
                            }
                        }
                    },
                    function () {
                        defer.reject();
                    }
                );
                return defer.promise;
            },
        };
    }]);
